module.exports = __webpack_public_path__ + "img/27.48382cc2.jpg";